import React from 'react';
import { titleCase, get } from "@dex/bubl-helpers";
import LeagueTeamApi from './LeagueTeamApi';

let settings;

export default settings = {
    key: 'league/teams',
    zone: 'leagues',
    path: '/league/teams',
    title: "League Team",
    endpoint: LeagueTeamApi.endpoint,
    modelName: 'LeagueTeam',
    idKey: 'id',
    primaryKey: 'name',
    actions: ['trash', 'clone'],
    indexCaps: ["viewLeagueTeam"],
    viewCaps: ["viewLeagueTeam"],
    createCaps: ["createLeagueTeam"],
    updateCaps: ["updateLeagueTeam"],
    indexTitle: (routeName, params, users) => {

        let title: string = settings.title;

        if (params && params.name) title = title + " / " + titleCase(params.name);

        return title;

    },
    indexTabs: (routeName, params, users) => {

        return [
            {
                label: "All",
                path: settings.path,
                caps: settings.indexCaps
            },
            {
                label: "Add New",
                path: settings.path + "/create",
                caps: settings.createCaps
            },
        ]

    },
    indexButtons: (routeName, params, users) => {

        return [
            {
                label: "Add New",
                path: settings.path + '/create',
                caps: settings.createCaps
            }
        ]

    },
    indexTabCounts: (routeName, params, dontation) => {

        return settings.endpoint + "/getCounts";

    },
    indexFetch: LeagueTeamApi.get,
    indexFetchParams: (routeName, params, users) => {

        const filters: any = { where: {}, include: ['manager'], order: ['created.date DESC'], limit: 10, skip: 0 };

        if (params && params.status) filters.where.status = { inq: [params.status] };

        return filters;

    },
    indexQuickSearch: (routeName, params, users) => {

        const fields = ['id'];

        return fields;

    },
    indexSearchFields: (routeName, params, users) => {

        const fields = [
            {
                label: "Name",
                key: "name",
                type: "text",
            },
        ];

        return fields;

    },

    indexColumns: (routeName, params, users) => {

        const columns = [
            {
                label: "Name",
                key: "this",
                format: "ModelLink",
            },
            {
                label: "Short Name",
                key: "shortName",
            },
            {
                label: "City",
                key: "city",
            },
            {
                label: "Manager",
                key: "manager",
                format: "ModelLink",
            },
            {
                label: "Manager's Email",
                key: "managersEmail",
            },
            {
                label: "Created Date",
                key: "created",
                format: "OnAndBy",
                sort: "created.date",
                alignEnd: true
            },
            {
                label: "Actions",
                key: "actions",
                alignEnd: true,
                format: "actions",
                api: LeagueTeamApi,
                settings: settings,
            }
        ];

        return columns;

    },
    singleFetch: LeagueTeamApi.getOne,
    singleFetchParams: (routeName, params, users, fetch) => {

        const filters = { include: ['manager'] };

        return filters;

    },
    singleTitle: (routeName, params, users, fetch) => {

        let title: string = "Loading...";

        const complete = get(fetch, 'complete');
        const error = get(fetch, 'error');
        const data = get(fetch, 'data');

        if (error) title = "Error";
        else if (data) title = data[settings.primaryKey];
        else if (complete && !data) title = "Not Found";

        return title;

    },
    singleTabs: (routeName, params, users, fetch) => {

        const path = settings.path + "/" + params.id;

        return [
            {
                label: "View",
                path: path + "/view"
            },
            {
                label: "Edit",
                path: path + "/edit",
                caps: settings.updateCaps
            },
        ]

    },
};